import * as React from 'react';
import { IOption } from '@cian/ui-kit';
import { Sorting } from '../../components/Sorting';
import { SORTING_OPTIONS } from '../../constants/sorting';
import { useDispatch } from 'react-redux';
import { setSortType } from '../../actions/filters';
import { fetchBuildersInfo } from '../../actions/buildersInfo';
import { TThunkDispatch } from '../../types/redux';
import { useSelectedSortOption } from '../../hooks/sort';
import { TSortType } from '../../types/filters';

export function SortingContainer() {
  const dispatch: TThunkDispatch = useDispatch();
  const selectedOption = useSelectedSortOption();
  const handleChange = React.useCallback(
    (option: IOption<TSortType>) => {
      dispatch(setSortType(option.value));
      dispatch(fetchBuildersInfo());
    },
    [dispatch],
  );

  return <Sorting selectedOption={selectedOption} options={SORTING_OPTIONS} onChange={handleChange} />;
}
